import { render, staticRenderFns } from "./MyShortcuts.vue?vue&type=template&id=8cbc3490&scoped=true"
import script from "./MyShortcuts.vue?vue&type=script&lang=js"
export * from "./MyShortcuts.vue?vue&type=script&lang=js"
import style0 from "./MyShortcuts.vue?vue&type=style&index=0&id=8cbc3490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbc3490",
  null
  
)

export default component.exports